import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { CancelScheduledOrderFOBActions } from "store/ducks/ordersFob";

export function* cancelScheduledOrderFOBRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.put,
      `/orders-fob-scheduled-cancel/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(CancelScheduledOrderFOBActions.success(data));
    notify("success", "Ordem cancelada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CancelScheduledOrderFOBActions.failure(errorMessage));
  }
}
